import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export default new VueI18n({
  locale: navigator.language.split('-')[0],
  messages: {
    'en': {
      auth: {
        user: 'A user wants to share information with you',
        passcodeInfo: 'Enter the six security digits provided by the user',
        done: 'DONE'
      },
      general: {
        title: 'Bowhead Health - User Report',
        page: 'Page {pageNum}/{pages}'
      }
    },
    'es': {
      auth: {
        user: 'Un usuario quiere compartir su información contigo.',
        passcodeInfo: 'Ingrese los seis dígitos de seguridad proporcionados por el usuario',
        done: 'LISTO'
      },
      general: {
        title: 'Bowhead Health - User Report',
        page: 'Pagina {pageNum}/{pages}'
      }
    },
    'ja': {
      auth: {
        user: 'ユーザーがあなたに情報を共有しようとしています',
        passcodeInfo: 'ユーザーから提供された6桁の セキュリティ番号を入力してください',
        done: '完了'
      },
      general: {
        title: 'Bowhead Health - ユーザーレポート',
        page: '頁 {pageNum}/{pages}'
      }
    }
  }
})
